import { keysToSnakeCase } from 'utils/obj'

import type { Company } from 'types/api/rbac/company'
import type { UserAuthCompany } from 'types/api/user/session'

export function getCompanyName(company: UserAuthCompany): string {
  return company?.alias ?? company?.name
}

/**
 * A function meant to transform company data responses while transitioning
 * to new model with 'entitlements' field. Normalizes field names to be snake case.
 */
export function getMappedCompanyData(
  companyData?: Company | Company[] | object
): Company | undefined {
  if (!companyData) return

  // todo: EN-6511 - this check and remapping is for backwards compatibility.
  // once entitlements are migrated, we can decide if we want to use the camel cased version of the properties
  if (Array.isArray(companyData)) {
    return companyData[0]
  }

  if (!('entitlements' in companyData)) return

  const { entitlements, ...rest } = companyData

  return {
    ...keysToSnakeCase(rest),
    entitlements
  }
}
